import { axiosInstance as request } from '@api/rest.service'

const api = '/title-lists'

/**
 * @description POST /title-lists/{id}/publications
 * @returns {AxiosPromise<any>}
 */
export const CREATE_TITLE_LIST_PUBLICATION = (id, payload) => request.post(`${api}/${id}/publications`)

/**
 * @description GET /title-lists/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_TITLE_LIST = id => request.get(`${api}/${id}`)

/**
 * @description GET /title-lists/{id}/publications?paginated=true (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_TITLE_LIST_PAGINATED_PUBLICATIONS = (id, params) =>
  request.get(`${api}/${id}/publications?paginated=true`, { params })

/**
 * @description PATCH /title-lists/{id}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_TITLE_LIST = (id, payload) => request.patch(`${api}/${id}`, payload)

/**
 * @description POST /title-lists/{id}/copy
 * @returns {AxiosPromise<any>}
 */
export const COPY_TITLE_LIST = id => request.post(`${api}/${id}/copy`)

/**
 * @description DELETE /title-lists/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_TITLE_LIST = id => request.delete(`${api}/${id}`)

/**
 * @description GET /title-lists/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_TITLE_LIST_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)
